import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { UserDTO } from '../../../models/DTO/user/user';
import { updateUserRequestModel } from '../../../models/requestModels/user/updateUserRequestModel';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  private getUserInfoURL : string = Config.api + "user/me?include=paymentAccounts%2Cvouchers%2CactiveCart.cartLines.sku.product.packaging%2CactiveCart.cartLines.sku.product.organisation%2CactiveCart.cartLines.sku.options.option%2Ccontacts%2CactiveCart.cartLines.sku.options.option.values%2CactiveCart.cartLines.sku.product.pricing&fields%5Busers%5D=id%2Cuuid%2Cfirst_name%2Clast_name%2Ctelephone_info%2Cemail%2Cwelcome_voucher_popup_pending&fields%5Bactive_cart%5D=id%2Cuuid%2Cuser_id%2Camount%2Ccurrency&fields%5Bactive_cart.cart_lines%5D=cart_id%2Cuuid%2Csku_id%2Cquantity%2Ctotal_amount%2Cprice_per_piece&fields%5Bactive_cart.cart_lines.sku%5D=id%2Cuuid%2Csku%2Cproduct_id%2Cavailable_quantity&fields%5Bactive_cart.cart_lines.sku.options%5D=id%2Csku_id%2Cuuid%2Cdisplay_value%2Coption_variation_id&fields%5Bactive_cart.cart_lines.sku.options.option%5D=id%2Cuuid%2Cdisplay_name&fields%5Bactive_cart.cart_lines.sku.product%5D=id%2Cuuid%2Cname%2Corganisation_id%2Cdeleted_at%2Cstate&fields%5Bactive_cart.cart_lines.sku.product.organisation%5D=id%2Cuuid%2Cnative_name%2Cname_in_latin%2Cfree_delivery_after_order_amount%2Cdelivery_to_courier_office_price%2Cdelivery_to_address_price";
  private updateUserInfoURL : string = Config.api + "user/update";
  private updateUserTelephoneURL : string = Config.api + "user/telephone_info";
  private deleteUserURL : string = Config.api + "user/me"
  private welcomeVoucherPopupSeenURL : string = Config.api + "user/welcome-voucher-popup/seen";




  constructor(private httpClient: HttpClient) { }

  loadUser() {
    return this.httpClient.get<UserDTO>(this.getUserInfoURL);
  }

  deleteUser() {
    return this.httpClient.delete(this.deleteUserURL);
  }

  updateUser(user: updateUserRequestModel) {
    return this.httpClient.put(this.updateUserInfoURL, user);
  }


  updateTelephone(telephone: string) {
    return this.httpClient.put(this.updateUserTelephoneURL, { telephone_info: telephone });
  }

  markWelcomeVoucherPopupAsSeen() {
    return this.httpClient.patch(this.welcomeVoucherPopupSeenURL, {});
  }

}
